<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap>
        <v-flex xs12>
          <h3 class="text-center">View Professional</h3>
          <p class="pull-right">
            <span v-if="professional.user_id != $user.id">
              <v-btn v-if="!professional.activated" small color="primary" @click="activate(professional)">Activate</v-btn>
              <v-btn v-else small color="primary" @click="inactive(professional)">{{ professional.activated }}</v-btn>
            </span>
            <v-btn small @click="goTo('/professionals/' + professional.id + '/edit')" class="primary" title="Edit">
              <v-icon left>mdi-lead-pencil</v-icon>Edit
            </v-btn>
            <v-menu>
              <template v-slot:activator="{ attrs, on }">
                <v-btn small icon fab text color="orange" v-bind="attrs" v-on="on">
                  <v-icon>{{ icons.help }}</v-icon>
                </v-btn>
              </template>
              <v-card flat>
                <v-card-text>
                  <h3>Activating Professionals</h3>
                  <activating-professional-help></activating-professional-help>
                </v-card-text>
              </v-card>
            </v-menu>
          </p>
        </v-flex>
        <v-flex xs12 sm10 md8>
          <view-professional :professional="professional" :errors="errors"></view-professional>
          <v-divider></v-divider>
          <v-layout wrap align-center>
            <v-flex d-flex>
              <wallet-component :balance="balance" :wallets="wallets" :credits="credits" :debits="debits"></wallet-component>
            </v-flex>
            <v-flex d-flex>
              <confirm-password @confirmed="goTo('/professionals/' + professional.id + '/wallets')">
                <v-btn class="pull-right" title="Debit or Credit account">
                  <v-icon left>mdi-cash</v-icon>Payout
                </v-btn>
              </confirm-password>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'
  const ViewProfessional = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "professionals" */ '@/Components/Professionals/show')
  import HelpMixin from '@/Mixins/helpComponent'
  const WalletComponent = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "wallets" */ '@/Components/Wallets/wallet')
  const ConfirmPassword = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/ConfirmsPassword')

  export default {
    name: 'ProfessionalView',
    layout,
    props: [
      'professional',
      'errors',
      'credits',
      'debits',
      'balance',
    ],
    mixins: [
      HelpMixin,
    ],
    components: {
      WalletComponent,
      ViewProfessional,
      ConfirmPassword,
    },
    metaInfo () {
      return {
        title: 'View Profession | ' + this.professional ? this.professional.name : '',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {}
    },
    methods: {
      inactive (prof) {
        swal({
          title: 'Deactivate ' + prof.name,
          text: 'The user won\'t be able to login',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'red',
        },
        function () {
          this.$inertia.post('/user/professional/' + prof.id + '/deactivate', {
            preserveScroll: true,
          })
        }.bind(this))
      },
      activate (prof) {
        swal({
          title: 'Activate ' + prof.name,
          text: 'The user will be able to login',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'green',
        },
        function () {
          this.$inertia.post('/user/professional/' + prof.id + '/activate', {
            preserveScroll: true,
          })
        }.bind(this))
      },
    },
    computed: {
      wallets () {
        return this.professional.wallets
      }
    }
  }
</script>
